import { dataMiniAppBaidu } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMiniAppBaidu = /*#__PURE__*/createIcon(dataMiniAppBaidu)
export default IconMiniAppBaidu
